var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
    _c("div", { ref: "container", staticClass: "flex-grow-1 h-100" }),
    _vm._v(" "),
    _c("div", { ref: "legend", staticClass: "flex-grow-0" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }